// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3cy7H","list":"PatternAutocomplete_list__1nvfq"};